"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var default_shared_store_1 = require("./default-shared-store");
var react_1 = require("react");
var shared_value_resolving_1 = require("./shared-value-resolving");
exports.SharedValueContext = react_1.createContext(new default_shared_store_1.DefaultSharedStore());
exports.APP_EVENTS = createSharedCollectionKey('app_events', function () { return new rxjs_1.Subject(); });
exports.AppInitialized = 'app_initialized';
exports.createSharedValueKey = function (id, defaultValue) { return ({ id: id, defaultValue: defaultValue }); };
function createSharedCollectionKey(name, values) {
    if (isResolver(values))
        return createResolvedCollectionKey(name, values);
    return {
        id: name,
        defaultValue: new default_shared_store_1.DefaultSharedStore(),
        defaultKeyValue: values,
        collection: true
    };
}
exports.createSharedCollectionKey = createSharedCollectionKey;
function createResolvedCollectionKey(name, resolver) {
    var collection = new default_shared_store_1.DefaultSharedStore();
    var collectionResolver = new shared_value_resolving_1.SharedCollectionResolver(name, collection, resolver);
    return {
        id: name,
        defaultValue: collection,
        collection: true,
        resolver: collectionResolver
    };
}
function isResolver(values) {
    return values && typeof values === 'object';
}
function sharedService(factory) {
    return factory;
}
exports.sharedService = sharedService;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2hhcmVkLXZhbHVlcy5tb2RlbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zaGFyZWQtdmFsdWVzL3NoYXJlZC12YWx1ZXMubW9kZWwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSw2QkFBeUM7QUFDekMsK0RBQTBEO0FBQzFELCtCQUE2QztBQUM3QyxtRUFBa0U7QUFFckQsUUFBQSxrQkFBa0IsR0FBeUIscUJBQWEsQ0FBQyxJQUFJLHlDQUFrQixFQUFTLENBQUMsQ0FBQztBQUMxRixRQUFBLFVBQVUsR0FBRyx5QkFBeUIsQ0FBc0IsWUFBWSxFQUFFLGNBQU0sT0FBQSxJQUFJLGNBQU8sRUFBRSxFQUFiLENBQWEsQ0FBQyxDQUFDO0FBQy9GLFFBQUEsY0FBYyxHQUFpQixpQkFBaUIsQ0FBQztBQXNCakQsUUFBQSxvQkFBb0IsR0FBRyxVQUFJLEVBQVUsRUFBRSxZQUFlLElBQXdCLE9BQUEsQ0FBQyxFQUFDLEVBQUUsSUFBQSxFQUFFLFlBQVksY0FBQSxFQUFDLENBQUMsRUFBcEIsQ0FBb0IsQ0FBQztBQWtCaEgsU0FBZ0IseUJBQXlCLENBQ3JDLElBQVksRUFDWixNQUEyRDtJQUUzRCxJQUFJLFVBQVUsQ0FBQyxNQUFNLENBQUM7UUFBRSxPQUFPLDJCQUEyQixDQUFDLElBQUksRUFBRSxNQUFNLENBQUMsQ0FBQztJQUV6RSxPQUFPO1FBQ0gsRUFBRSxFQUFFLElBQUk7UUFDUixZQUFZLEVBQUUsSUFBSSx5Q0FBa0IsRUFBRTtRQUN0QyxlQUFlLEVBQUUsTUFBTTtRQUN2QixVQUFVLEVBQUUsSUFBSTtLQUNuQixDQUFDO0FBQ04sQ0FBQztBQVpELDhEQVlDO0FBRUQsU0FBUywyQkFBMkIsQ0FBSSxJQUFZLEVBQUUsUUFBZ0M7SUFDbEYsSUFBTSxVQUFVLEdBQUcsSUFBSSx5Q0FBa0IsRUFBRSxDQUFDO0lBQzVDLElBQU0sa0JBQWtCLEdBQUcsSUFBSSxpREFBd0IsQ0FBQyxJQUFJLEVBQUUsVUFBVSxFQUFFLFFBQVEsQ0FBQyxDQUFDO0lBRXBGLE9BQU87UUFDSCxFQUFFLEVBQUUsSUFBSTtRQUNSLFlBQVksRUFBRSxVQUFVO1FBQ3hCLFVBQVUsRUFBRSxJQUFJO1FBQ2hCLFFBQVEsRUFBRSxrQkFBa0I7S0FDL0IsQ0FBQztBQUNOLENBQUM7QUFFRCxTQUFTLFVBQVUsQ0FBSSxNQUEwRDtJQUM3RSxPQUFPLE1BQU0sSUFBSSxPQUFPLE1BQU0sS0FBSyxRQUFRLENBQUM7QUFDaEQsQ0FBQztBQUdELFNBQWdCLGFBQWEsQ0FBMEIsT0FBZ0M7SUFDbkYsT0FBTyxPQUFPLENBQUM7QUFDbkIsQ0FBQztBQUZELHNDQUVDIn0=